import Resizer from "react-image-file-resizer";

export type ReformattedImage = string | Blob | ProgressEvent<FileReader>;

export const formatImage = (imageFile: File): Promise<ReformattedImage> => {
  return new Promise((resolve) => {
    Resizer.imageFileResizer(
      imageFile,
      1200, // max height
      1200, // max width
      "JPEG", // image output file type
      100, // image quality (0-100)
      0, // rotation (0, 90, 180, 270, 360)
      (imageBase64) => resolve(imageBase64),
      "base64"
    );
  });
};
